<template>
  <div class="form_row">
    <!-- PAYMENT SELECT -->
    <b-form-select
        ref="paymentSelect"
        v-model="selectedPaymentId"
        :options="paymentOptions"
        placeholder="Select date"
        style="width:100%;"
        tabindex="0"
        @change="emitChange"
        @keydown.native="handlePaymentKeyDown"
    />

    <!-- +ADD BUTTON (owned here) -->
    <b-button
        v-if="showAddButton"
        ref="addBtn"
        :disabled="!canAdd"
        class="btn btn-info add_button"
        style="height: 33px;"
        size="sm"
        tabindex="0"
        @click="emitAdd"
        @keydown="handleAddKeyDown"
    >
      + Add
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true },
    payments: { type: Array, required: true },
    showAddButton: { type: Boolean, default: false }
  },

  data() {
    return {
      selectedPaymentId: this.value.payment_id || null,
      descriptionText: this.value.description || ''
    };
  },

  watch: {
    value: {
      deep: true,
      handler(newVal) {
        this.selectedPaymentId = newVal.payment_id || null;
        this.descriptionText = newVal.description || '';
      }
    }
  },

  computed: {
    paymentOptions() {
      return this.payments.map(p => ({
        value: p.id,
        text: `${p.pay_date} — ${p.pay_weekday}`
      }));
    },
    canAdd() {
      return this.selectedPaymentId !== null;
    }
  },

  methods: {
    emitChange() {
      this.$emit('input', {
        payment_id: this.selectedPaymentId,
        description: this.descriptionText
      });
    },

    emitAdd() {
      this.$emit('add', {
        payment_id: this.selectedPaymentId,
        description: this.descriptionText
      });
      this.$emit('advance');
    },

    handlePaymentKeyDown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.$emit('reset');
        return;
      }

      if (e.key === 'ArrowLeft' || (e.key === 'Tab' && e.shiftKey)) {
        e.preventDefault();
        this.$emit('retreat');
        return;
      }

      if (['Tab', 'Enter', 'ArrowRight'].includes(e.key)) {
        e.preventDefault();
        if (this.showAddButton && this.canAdd && this.$refs.addBtn) {
          this.$refs.addBtn.focus();
        } else {
          this.$emit('advance');
        }
      }
    },

    handleAddKeyDown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.$emit('reset');
        return;
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.$emit('retreat');
        return;
      }

      if ([' ', 'Spacebar', 'Enter'].includes(e.key)) {
        e.preventDefault();
        if (!this.$refs.addBtn?.disabled) this.emitAdd();
        return;
      }

      if (['Tab', 'ArrowRight'].includes(e.key)) {
        e.preventDefault();
        this.$emit('advance');
      }
    },

    focusPayment() {
      this.$nextTick(() => {
        const el = this.$refs.paymentSelect?.$el?.querySelector('select');
        (el || this.$refs.paymentSelect)?.focus?.();
      });
    },

    focusPaymentInput() {
      this.focusPayment();
    }
  }
};
</script>


<style lang="scss" scoped>
.form_row {
  max-width: 350px;
  display: grid;
  grid-template-columns: 280px 50px;
  margin-left: 15px;
  grid-gap: 10px;
  height: 33px;
}
.add_button { height:100%; width:100%; background-color:#d6006e; }
</style>
